const clickDividendHistory = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'open_modal',
    'modal_name ': 'dividend_history'
  })
}

const clickStockChart = (data) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'click_stock_chart',
    'stockData': {
      sectionID: data.sectionID,
      thName: data.thName,
      enName: data.enName
    }
  })
}

const clickCreatePlan = (data) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'click_create_plan',
    ...data
  })
}

const openMiniAppPage = (data) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'miniappPage',
    ...data
  })
}

const openModalTermsAndConditions = () => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event': 'privacy_banner',
  })
}

export {
  clickDividendHistory,
  clickStockChart,
  clickCreatePlan,
  openMiniAppPage,
  openModalTermsAndConditions
}